class DetectController {

	constructor() {
		this.isTablet = window.matchMedia('(min-width: 768px)').matches;
		this.isDesktop = window.matchMedia('(min-width: 1024px)').matches;
		this.isDesktopXL = window.matchMedia('(min-width: 1280px)').matches;
	}

	isIE() {
		const ua = window.navigator.userAgent;
		const msie = ua.indexOf('MSIE ');
		const trident = ua.indexOf('Trident/');
		return (msie > 0 || trident > 0);
	}

}

export default new DetectController();
